// src/components/store/sections/testimonials/TestimonialV4BubblechatEmeraldMint.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV4BubblechatEmeraldMint(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={4}
      archKey="bubble_chat"
      archLabel="Bubble Chat Cards"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
